import { Directive, TemplateRef } from "@angular/core";

@Directive({ selector: "[radrQueryEntity]" })
export class QueryEntityDirective {
  constructor(public template: TemplateRef<any>) {}
}
